import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { fetchBlogPostBySlug } from '../api/blogApi';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchBlogPostBySlug(slug);
        setPost(data);
      } catch (e) {
        setErr(String(e?.message || e));
      }
    })();
  }, [slug]);

  if (err) return <p className="p-10 text-center text-red-600">❌ {err}</p>;
  if (!post) return <p className="p-10 text-center opacity-70">Loading…</p>;

  const cover = post.coverImage || { url: '', alt: '' };

  return (
    <article className="max-w-3xl mx-auto px-6 py-10">
      <NavLink to="/blog" className="text-sm text-indigo-600 hover:underline mb-6 inline-block">
        ← Back to Blog
      </NavLink>
      {/* Featured image (with graceful fallback) */}
      {cover.url && (
        <img
          src={cover.url}
          alt={cover.alt}
          className="w-full aspect-[16/9] object-cover rounded-2xl mb-8 shadow-sm"
          loading="eager"
        />
      )}

      {/* Title + date */}
      <h1
        className="text-3xl font-bold mb-2"
        dangerouslySetInnerHTML={{ __html: post.titleHtml || "" }}
      />
      <div className="text-sm opacity-70 mb-6">
        {post.date ? new Date(post.date).toLocaleDateString() : ""}
      </div>

      {/* WP HTML body */}
      <div
        className="wp-content prose prose-lg max-w-none"
        dangerouslySetInnerHTML={{ __html: post.contentHtml || "" }}
      />
    </article>
  );
}
